module.exports = __webpack_public_path__ + "img/modal_bg.03168dfd.png";